<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn v-bind="activatorProps" icon variant="text" dark size="small">
        <v-icon size="18">mdi-emoticon-excited-outline</v-icon>
      </v-btn>
    </template>

    <template v-slot:default="{}">
      <div class="d-flex align-center justify-center">
        <EmojiPicker
          style="position: relative"
          :native="true"
          @select="onSelectEmoji"
        ></EmojiPicker>
      </div>
    </template>
  </v-dialog>
</template>

<script>
import EmojiPicker from "vue3-emoji-picker";
import "vue3-emoji-picker/css";

export default {
  data() {
    return {
      dialog: false,
    };
  },
  components: {
    EmojiPicker,
  },
  methods: {
    onSelectEmoji(v) {
      console.log(v.i);
      //   this.dialog = false;
      this.$emit("insert", v.i);
    },
  },
};
</script>
